import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import { headingsSchema } from '../Header';
import EquityBox from './EquityBox';

const schema: JSONSchema7 = {
    title: 'Equity Box',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        chartTitles: headingsSchema,
        xGridValues: {
            type: 'string',
            default: '0,1,2,3',
            title: 'X-Axis Grids',
        },
        yGridValues: {
            type: 'string',
            default: '0,1,2,3',
            title: 'Y-Axis Grids',
        },
        selectionSequence: {
            type: 'string',
            default: '2,1,0',
            title: 'Selection sequence Top / Bottom',
        },
        xLabelsValue: {
            type: 'string',
            title: 'X-Axis Labels',
            description: 'Comma seperated values',
        },
        yLabelsValue: {
            type: 'string',
            title: 'Y-Axis Labels',
            description: 'Comma seperated values',
        },
        dataKey: {
            type: 'string',
            title: 'Data key',
        },
        transformData: {
            type: 'boolean',
            title: 'Transform Data',
            default: false,
        },
    },
    dependencies: {
        transformData: {
            oneOf: [
                {
                    properties: {
                        transformData: { enum: [true] },
                        functionToTransformData: {
                            type: 'string',
                            description: 'Function to transform Data',
                            default: 'return (data) => { return data}',
                        },
                    },
                },
            ],
        },
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: [
            'chartTitles',
            'xGridValues',
            'yGridValues',
            'selectionSequence',
            'xLabelsValue',
            'yLabelsValue',
            'dataKey',
        ],
        'Transform Data': ['transformData', 'functionToTransformData'],
    },
];

const uiSchema = {
    'ui:groups': groups,
    ...customSchemas.textSchema.TextSchema.uiSchema,
    ...customSchemas.styleSchema.StyleSchema.uiSchema,
    ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
    styles: {
        'ui:widget': 'CSSEditor',
    },
    chartTitles: {
        items: {
            headerText: {
                'ui:widget': 'ResourcePicker',
            },
        },
    },
    functionToTransformData: { 'ui:widget': 'JSEditor' },
    xGridValues: {
        'ui:widget': 'CustomTextInput',
    },
    yGridValues: {
        'ui:widget': 'CustomTextInput',
    },
    selectionSequence: {
        'ui:widget': 'CustomTextInput',
    },
    xLabelsValue: {
        'ui:widget': 'CustomTextInput',
    },
    yLabelsValue: {
        'ui:widget': 'CustomTextInput',
    },
    dataKey: {
        'ui:widget': 'CustomTextInput',
    },
};

const EquityBoxWidget: commonTypes.IWidget = {
    schema,
    uiSchema,
    templateView: EquityBox,
    id: 'EquityBox',
    group: 'component',
    contentPlaceHolders: ['children'],
    initialData: () => ({
        xGrids: '0,1,2,3',
        yGrids: '0,1,2,3',
        selectionSequence: '2,1,0',
    }),
};

export default EquityBoxWidget;
